// src/lib/utils/format/data/special-cases.ts
// AUTO-SPLIT from lib/utils/formatters.ts (A10/A2). New code: import from ~/lib/utils/format.

/**
 * Default special cases for text formatting that override normal capitalization rules.
 * Common acronyms, product names, and technical terms that should maintain specific casing.
 * 
 * @constant {Record<string, string>} DEFAULT_SPECIAL_CASES
 */
export const DEFAULT_SPECIAL_CASES: Record<string, string> = {
  // Technology & Web
  'api': 'API',
  'apis': 'APIs',
  'css': 'CSS',
  'html': 'HTML',
  'http': 'HTTP',
  'https': 'HTTPS',
  'json': 'JSON',
  'jwt': 'JWT',
  'oauth': 'OAuth',
  'rest': 'REST',
  'xml': 'XML',
  'url': 'URL',
  'urls': 'URLs',
  'sdk': 'SDK',
  'sdks': 'SDKs',
  'ui': 'UI',
  'ux': 'UX',
  'ip': 'IP',
  
  // Programming & Development
  'npm': 'npm',
  'github': 'GitHub',
  'javascript': 'JavaScript',
  'typescript': 'TypeScript',
  
  // Apple Products
  'ios': 'iOS',
  'iphone': 'iPhone',
  'ipad': 'iPad',
  
  // Marketing & Business Metrics
  'roas': 'ROAS',
  'cpm': 'CPM',
  'cpc': 'CPC',
  'cpa': 'CPA',
  'ctr': 'CTR',
  'cvr': 'CVR',
  'roi': 'ROI',
  'mrr': 'MRR',
  'arr': 'ARR',
  'mer': 'MER',
  'amer': 'aMER',
  'nmer': 'nMER',
  'kpi': 'KPI',
  'kpis': 'KPIs',
  'okr': 'OKR',
  'okrs': 'OKRs',
  'seo': 'SEO',
  'sem': 'SEM',
  'ppc': 'PPC',
  'cro': 'CRO',
  'ltv': 'LTV',
  'clv': 'CLV',
  'cac': 'CAC',
  'aov': 'AOV',
  
  // Business Models & Types
  'saas': 'SaaS',
  'b2b': 'B2B',
  'b2c': 'B2C',
  'd2c': 'D2C',
  'b2b2c': 'B2B2C',
  'b2g': 'B2G',
  
  // Executive Roles
  'ceo': 'CEO',
  'cfo': 'CFO',
  'cto': 'CTO',
  'cmo': 'CMO',
  
  // Technology & AI
  'ai': 'AI',
  'ml': 'ML',
  'llm': 'LLM',
  'nlp': 'NLP',
  'tts': 'TTS',
  
  // Platforms & Media
  'tv': 'TV',
  'ott': 'OTT',
  'ctv': 'CTV',
  'tiktok': 'TikTok',
  'youtube': 'YouTube',
  'linkedin': 'LinkedIn',
  
  // Business Systems
  'crm': 'CRM',
  'erp': 'ERP',
  
  // Marketing Funnel Terms
  'a/b testing': 'A/B Testing',
  'a/b test': 'A/B Test',
  'smart tv': 'Smart TV',
  '(tofu)': '(TOFU)',
  '(mofu)': '(MOFU)',
  '(bofu)': '(BOFU)',
  'tofu': 'TOFU',
  'mofu': 'MOFU',
  'bofu': 'BOFU',
  'top of funnel': 'Top of Funnel',
  'middle of funnel': 'Middle of Funnel',
  'bottom of funnel': 'Bottom of Funnel',
  
  // File Formats & Standards
  'pdf': 'PDF',
  'csv': 'CSV',
  'xlsx': 'XLSX',
  'docx': 'DOCX',
  'pptx': 'PPTX',
  'png': 'PNG',
  'jpg': 'JPG',
  'jpeg': 'JPEG',
  'gif': 'GIF',
  'svg': 'SVG',
  'webp': 'WebP',
  'mp4': 'MP4',
  'avi': 'AVI',
  'mov': 'MOV',
  'wmv': 'WMV',
  'mp3': 'MP3',
  'wav': 'WAV',
  'flac': 'FLAC',
  'aac': 'AAC',
} as const
